import * as React from 'react';
import Button from '@websky/core/src/Button';
import css from './OrderAdditionalBanner.css';
import { ArrowForward } from '@websky/core/src/Icons';
import { useTranslation } from 'react-i18next';

interface Props {
	bookingUrl: string;
}

const OrderAdditionalBanner: React.FC<Props> = props => {
	const { t } = useTranslation('Checkout');

	return (
		<div className={css.banner}>
			<div className={css.text}>
				<div className={css.text__title}>{t('Extra comfort')}</div>
				<div className={css.text__description}>
					{t('VIP lounges, business lounges, priority pre-flight procedures')}
				</div>

				<Button
					variant="flat"
					size="small"
					className={css.text__button}
					onClick={() => window.open(props.bookingUrl, '_blank')}
				>
					{t('To book')} {ArrowForward}
				</Button>
			</div>

			<div className={css.picture} />
		</div>
	);
};

export default OrderAdditionalBanner;
